import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { useRef } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { supabase } from "../supabaseClient";
import { FiStar, FiChevronDown, FiChevronUp } from "react-icons/fi";
import SEOHelmet, {
  siteUrl,
  aboutPageSchema,
  buildBreadcrumb,
  buildFAQSchema,
} from "../components/SEOHelmet";

const About = () => {
  const feedbackPrevRef = useRef(null);
  const feedbackNextRef = useRef(null);
  const aboutPrevRef = useRef(null);
  const aboutNextRef = useRef(null);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openFaq, setOpenFaq] = useState(0);

  const fetchReviews = async () => {
    try {
      const { data, error } = await supabase
        .from("reviews")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) throw error;
      setReviews(data || []);
    } catch (err) {
      console.error("Error fetching reviews:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    fetchReviews();
  }, []);

  const getInitials = (title) => {
    if (!title) return "?";
    const words = title.trim().split(/\s+/);
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return title[0].toUpperCase();
  };

  const getAvatarColor = (title) => {
    if (!title) return "#7c3aed";
    const colors = [
      "#7c3aed",
      "#ec4899",
      "#f59e0b",
      "#10b981",
      "#3b82f6",
      "#ef4444",
    ];
    const index = title.charCodeAt(0) % colors.length;
    return colors[index];
  };
  const faqItems = [
    {
      question: "Where would the session take place?",
      answer: "The session would ideally take place in our Studio. Indoor - Baby Twinkles Photography Madhapur Ayyappa Society. Outdoor - Gulmohar Park Serilingampally.",
    },
    {
      question: "How early should I book my session?",
      answer: "You should book your session as early as possible. We book up to 15 days in advance. Last minute availability should be checked with us by calling us on 8074597649.",
    },
    {
      question: "How do I book my session?",
      answer: "You can book your session by calling/WhatsApp on 8074597649. Your booking is considered confirmed only once you pay a deposit. The balance is payable before your session ends.",
    },
    {
      question: "How to select the themes?",
      answer: "We share themes PDF for Indoor and Outdoor. Select and send to us one day before shoot date.",
    },
    {
      question: "What about costumes?",
      answer: "We provide themes based costumes. Cake smash dress and family portraits dress need to carry. Carry two or three more dresses for baby (optional).",
    },
    {
      question: "When is the best time to get a cakesmash shoot done and cake size?",
      answer: "10-12 months is ideal for a cakesmash/pre-birthday shoot. Cake should be bought by the client. Make sure the cake doesn't weigh more than 1-2 kgs.",
    },
    {
      question: "How long will you store the client data?",
      answer: "Edited and raw data will be stored with us only for One month after the date of the shoot. Please download your high quality edited and raw images within one week from the date of transfer from our end. The download link expires in few days once we send.",
    },
    {
      question: "How about the deliverables?",
      answer: "Edited images will be given within one week after selection. Selection for photos your choice, Video will take 7-10 days. Any changes in the edited video will be done only once, after editings we remove raw data.",
    },
    {
      question: "When will you deliver the photos and video?",
      answer: "It takes about 5-7 days to deliver the images after selection and deliver the video 7-10 days.",
    },
    {
      question: "Which song should we select for edited video?",
      answer: "Song suggestions will be done by us. If you have any particular song please inform us in the prior. Once song is confirmed it cannot be changed for any reasons.",
    },
    {
      question: "What time should we reach your studio? How long will the session last?",
      answer: "It is advisable to reach our studio atleast 15 minutes prior to your session. Date and timings are according to the booking. Your session lasts up to - 1 to 2 hours for only photo including video. Including video takes 5 hours for indoor and outdoor for only outdoor 1 to 2 hours. However sometimes though babies can take a bit longer to settle, so ultimately we are at their mercy.",
    },
    {
      question: "Short note for indoor shoot",
      answer: "Need to pay 2k booking advance after date confirmation to block date. Payment number 9705603287 GPay or Paytm name Ramya. Need to carry cake and cake smash dress for baby. Need to carry costumes for family portraits. Themes based costumes we provide for baby.",
    },
    {
      question: "Short note for indoor and outdoor shoots",
      answer: "Need to pay 2k booking advance after date confirmation to block date. Payment number 9705603287 GPay or Paytm name Ramya. Need to pay entrance ticket at park 1,000 rupees. Need to carry cake and cake smash dress. Need to carry dresses for family portraits and few dresses for baby to outdoor. Indoor and outdoor themes based costumes we provide.",
    },
  ];

  return (
    <>
      {/* ── SEO ── */}
      <SEOHelmet
        title="About Us | Hyderabad's Best Baby & Newborn Photography Studio"
        description="Learn about Baby Twinkles Photography – Hyderabad's most trusted baby & newborn photography studio in Madhapur. Our passionate team creates timeless portraits of your little ones. Book a session today!"
        keywords="about baby twinkles photography, baby photographer Hyderabad, best newborn photographer Hyderabad, professional baby photography studio Madhapur, trusted baby photographer Hyderabad, newborn photography studio Hyderabad, baby photographer Ayyappa Society, baby photoshoot Madhapur Hyderabad"
        canonicalUrl={`${siteUrl}/about`}
        schema={[
          aboutPageSchema,
          buildBreadcrumb([
            { name: "Home", url: `${siteUrl}/` },
            { name: "About", url: `${siteUrl}/about` },
          ]),
          buildFAQSchema(faqItems),
        ]}
      />
      <div className="inner-page-banner" data-aos="fade-down"> 
        <div className="banner-wrapper">
          <div className="container-fluid">
            <div className="banner-main-content-wrap">
              <div className="row">
                <div className="col-12">
                  <div className="banner-content">
                    <ul className="breadcrumb-list mt-5 pt-5 d-flex justify-content-center align-items-center">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>About</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="home4-about-section my-4">
        <div className="container">
          <div className="row g-lg-4 gy-3">
          <div className="col-lg-6 order-2 order-lg-1">
              <div
                className="about-img-wrap"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <Swiper
                  className="home3-about-img-slider"
                  modules={[Navigation]}
                  slidesPerView={1}
                  spaceBetween={25}
                  navigation={{
                    prevEl: aboutPrevRef.current,
                    nextEl: aboutNextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = aboutPrevRef.current;
                    swiper.params.navigation.nextEl = aboutNextRef.current;
                  }}
                >
                  <SwiperSlide>
                                     <img src="/assets/img/babies/hero1.png" alt style={{ width: "100%", height: "400px", objectFit: "cover" }} />
                                   </SwiperSlide>
                                   <SwiperSlide>
                                     <img src="/assets/img/babies/hero2.png" alt style={{ width: "100%", height: "400px", objectFit: "cover" }} />
                                   </SwiperSlide>
                                   <SwiperSlide>
                                     <img src="/assets/img/babies/hero3.png" alt style={{ width: "100%", height: "400px", objectFit: "cover" }} />
                                   </SwiperSlide>
                                   <SwiperSlide>
                                     <img src="/assets/img/babies/hero4.png" alt style={{ width: "100%", height: "400px", objectFit: "cover" }} />
                                   </SwiperSlide>
                  <div className="slider-btn-group2">
                    <div className="slider-btn prev-6" ref={aboutPrevRef}>
                      <svg
                        width={9}
                        height={15}
                        viewBox="0 0 8 13"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0 6.50008L8 0L2.90909 6.50008L8 13L0 6.50008Z" />
                      </svg>
                    </div>
                    <div className="slider-btn next-6" ref={aboutNextRef}>
                      <svg
                        width={9}
                        height={15}
                        viewBox="0 0 8 13"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M8 6.50008L0 0L5.09091 6.50008L0 13L8 6.50008Z" />
                      </svg>
                    </div>
                  </div>
                </Swiper>
              </div>
            </div>
          <div className="col-lg-6 order-1 order-lg-2">
              <div
                className="about-content-wrap"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="section-title1">
                  <h2 className="d-lg-block d-none">Get To Know About Baby Twinkles Photography</h2>
                </div>
                <h6>Welcome to our Baby Twinkles Photography! </h6>
                <p>
                  Capture the precious moments of your little ones with our
                  professional baby photography services. We specialize in
                  newborn, milestone, and family photography, ensuring that
                  every smile and twinkle is preserved forever. Book a session
                  with us to create beautiful memories that will last a
                  lifetime. Our creative team provides a comfortable and safe
                  environment for every photoshoot, making each session
                  enjoyable for both babies and parents. With carefully designed
                  themes, professional lighting, and attention to every detail,
                  we create stunning portraits that tell your family's unique
                  story. Let us turn your cherished moments into timeless works
                  of art that you will treasure for generations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="how-it-work-section mb-4">
        <div className="container">
          <div className="row mb-50 wow fadeInUp" data-wow-delay="200ms">
            <div className="col-lg-12 d-flex align-items-end justify-content-between gap-3 flex-wrap">
              <div className="section-title-2">
                <h2>How Does It Work</h2>
                <p>
                  Here is our simple process for booking a photography session
                  with us.
                </p>
              </div>
              <div className="video-btn d-none d-lg-block">
                <a href="tel:+918074597649">
                  <i className="bi bi-telephone-fill" /> Call Now
                </a>
              </div>
            </div>
          </div>
          <div className="row wow fadeInUp" data-wow-delay="300ms">
            <div className="col-lg-12">
              <div className="work-process-group">
                <div className="row justify-content-center g-lg-0 gy-5">
                  <div className="col-lg-3 col-sm-6">
                    <div className="single-work-process text-center">
                      <div className="step">
                        <span>01</span>
                      </div>
                      <div className="icon">
                        <img src="assets/img/home2/icon/loaction.svg" alt />
                      </div>
                      <div className="content">
                        <h6>Choose A Package</h6>
                        <p>
                          Select the perfect photography package for your baby's
                          needs.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6">
                    <div className="single-work-process text-center">
                      <div className="step">
                        <span>02</span>
                      </div>
                      <div className="icon">
                        <img src="assets/img/home2/icon/contact.svg" alt />
                      </div>
                      <div className="content">
                        <h6>Book A Session</h6>
                        <p>
                          Contact us to schedule a convenient time for your
                          photoshoot.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6">
                    <div className="single-work-process text-center">
                      <div className="step">
                        <span>03</span>
                      </div>
                      <div className="icon">
                        <img src="assets/img/home2/icon/pay.svg" alt />
                      </div>
                      <div className="content">
                        <h6>Enjoy The Shoot</h6>
                        <p>
                          Relax and have fun while we capture beautiful moments.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6">
                    <div className="single-work-process text-center">
                      <div className="step">
                        <span>04</span>
                      </div>
                      <div className="icon">
                        <img src="assets/img/home2/icon/recieve.svg" alt />
                      </div>
                      <div className="content">
                        <h6>Receive Your Photos</h6>
                        <p>
                          Get your high-quality, professionally edited photos.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="customar-feedback-area mb-2 ">
        <div className="container">
          <div className="row mb-3" data-aos="fade-up" data-aos-delay="200">
            <div className="col-lg-12">
              <div className="section-title1">
                <span>Customer Feedback</span>
                <h2>What Our Customers Are Saying</h2>
              </div>
            </div>
          </div>
          <div className="row g-4 mb-4">
            <div className="col-lg-12" data-aos="fade-up" data-aos-delay="200">
              <div className="customer-feedback-right">
                <Swiper
                  className="customer-feedback-slider mb-3"
                  modules={[Navigation, Autoplay]}
                  slidesPerView={1}
                  speed={1500}
                  spaceBetween={25}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  navigation={{
                    prevEl: feedbackPrevRef.current,
                    nextEl: feedbackNextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = feedbackPrevRef.current;
                    swiper.params.navigation.nextEl = feedbackNextRef.current;
                  }}
                  breakpoints={{
                    280: {
                      slidesPerView: 1,
                    },
                    386: {
                      slidesPerView: 1,
                    },
                    576: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 15,
                    },
                    992: {
                      slidesPerView: 3,
                      spaceBetween: 15,
                    },
                    1200: {
                      slidesPerView: 3,
                      spaceBetween: 15,
                    },
                    1400: {
                      slidesPerView: 3,
                    },
                  }}
                >
                  {loading ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                      Loading reviews...
                    </div>
                  ) : reviews.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                      No reviews yet.
                    </div>
                  ) : (
                    reviews.map((review) => (
                      <SwiperSlide key={review.id}>
                        <div className="feedback-card">
                          <div className="author-name">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                              }}
                            >
                              <div
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  borderRadius: "50%",
                                  backgroundColor: getAvatarColor(review.title),
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#fff",
                                  fontWeight: "600",
                                  fontSize: "18px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {getInitials(review.title)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "4px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "4px",
                                    color: "#fbbf24",
                                    fontSize: "14px",
                                  }}
                                >
                                  <FiStar fill="#fbbf24" />
                                  <FiStar fill="#fbbf24" />
                                  <FiStar fill="#fbbf24" />
                                  <FiStar fill="#fbbf24" />
                                  <FiStar fill="#fbbf24" />
                                </div>
                                <h6 style={{ margin: 0 }}>{review.title}</h6>
                              </div>
                              <div
                                className="logo"
                                style={{ marginLeft: "auto" }}
                              >
                                <img
                                  src="assets/img/home1/icon/google3.svg"
                                  alt
                                />
                              </div>
                            </div>
                          </div>
                          <p>{review.description}</p>
                        </div>
                      </SwiperSlide>
                    ))
                  )}
                </Swiper>
                {/* <div className="row ">
                  <div className="col-lg-12 divider">
                    <div className="slider-btn-group style-2 justify-content-md-between justify-content-center">
                      <div
                        className="slider-btn prev-4 d-md-flex d-none"
                        ref={feedbackPrevRef}
                      >
                        <svg
                          width={11}
                          height={19}
                          viewBox="0 0 8 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M0 6.50008L8 0L2.90909 6.50008L8 13L0 6.50008Z" />
                        </svg>
                      </div>
                      <div
                        className="slider-btn next-4 d-md-flex d-none"
                        ref={feedbackNextRef}
                      >
                        <svg
                          width={11}
                          height={19}
                          viewBox="0 0 8 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M8 6.50008L0 0L5.09091 6.50008L0 13L8 6.50008Z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="preparation-guide-section py-4">
        <div className="container">
          <div className="row mb-4" data-aos="fade-up" data-aos-delay="200">
            <div className="col-lg-12 text-center">
              <div className="section-title-2">
                <h2>Preparation Guide</h2>
                <p>Everything you need to know before your photoshoot</p>
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="300">
              <div 
                className="preparation-card p-3 position-relative overflow-hidden"
                style={{ 
                  borderRadius: "15px", 
                  background: "#fff",
                  boxShadow: "0 10px 40px rgba(124, 58, 237, 0.1)",
                  border: "2px solid transparent",
                  backgroundClip: "padding-box",
                  position: "relative"
                }}
              >
                <div style={{
                  position: "absolute",
                  inset: "-2px",
                  borderRadius: "17px",
                  padding: "2px",
                  background: "linear-gradient(45deg, #7c3aed, #ec4899, #7c3aed)",
                  backgroundSize: "200% 200%",
                  animation: "gradientBorder 3s ease infinite",
                  zIndex: -1
                }}></div>
                <h4 style={{ color: "#7c3aed", marginBottom: "15px", fontSize: "1.3rem", fontWeight: "700" }}>For Indoor Shoot</h4>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start" }}>
                    <span style={{ color: "#7c3aed", marginRight: "10px", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                    <span style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>Need to pay 2k booking advance after date confirmation to block date</span>
                  </li>
                  <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start" }}>
                    <span style={{ color: "#7c3aed", marginRight: "10px", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                    <span style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>Payment number 9705603287 GPay or Paytm name Ramya</span>
                  </li>
                  <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start" }}>
                    <span style={{ color: "#7c3aed", marginRight: "10px", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                    <span style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>Need to carry cake and cake smash dress for baby</span>
                  </li>
                  <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start" }}>
                    <span style={{ color: "#7c3aed", marginRight: "10px", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                    <span style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>Need to carry costumes for family portraits</span>
                  </li>
                  <li style={{ marginBottom: "0", display: "flex", alignItems: "flex-start" }}>
                    <span style={{ color: "#7c3aed", marginRight: "10px", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                    <span style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>Themes based costumes we provide for baby</span>
                  </li>
                </ul>
                <style>{`
                  @keyframes gradientBorder {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                  }
                `}</style>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="400">
              <div 
                className="preparation-card p-3 position-relative overflow-hidden"
                style={{ 
                  borderRadius: "15px", 
                  background: "#fff",
                  boxShadow: "0 10px 40px rgba(239, 185, 63, 0.1)",
                  border: "2px solid transparent",
                  backgroundClip: "padding-box",
                  position: "relative"
                }}
              >
                <div style={{
                  position: "absolute",
                  inset: "-2px",
                  borderRadius: "17px",
                  padding: "2px",
                  background: "linear-gradient(45deg, #efb93f, #f59e0b, #efb93f)",
                  backgroundSize: "200% 200%",
                  animation: "gradientBorder2 3s ease infinite",
                  zIndex: -1
                }}></div>
                <h4 style={{ color: "#efb93f", marginBottom: "15px", fontSize: "1.3rem", fontWeight: "700" }}>For Indoor & Outdoor Shoots</h4>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start" }}>
                    <span style={{ color: "#efb93f", marginRight: "10px", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                    <span style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>Need to pay 2k booking advance after date confirmation to block date</span>
                  </li>
                  <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start" }}>
                    <span style={{ color: "#efb93f", marginRight: "10px", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                    <span style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>Payment number 9705603287 GPay or Paytm name Ramya</span>
                  </li>
                  <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start" }}>
                    <span style={{ color: "#efb93f", marginRight: "10px", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                    <span style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>Need to pay entrance ticket at park 1,000 rupees</span>
                  </li>
                  <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start" }}>
                    <span style={{ color: "#efb93f", marginRight: "10px", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                    <span style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>Need to carry cake and cake smash dress</span>
                  </li>
                  <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start" }}>
                    <span style={{ color: "#efb93f", marginRight: "10px", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                    <span style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>Need to carry dresses for family portraits and few dresses for baby to outdoor</span>
                  </li>
                  <li style={{ marginBottom: "0", display: "flex", alignItems: "flex-start" }}>
                    <span style={{ color: "#efb93f", marginRight: "10px", fontSize: "16px", fontWeight: "bold" }}>✓</span>
                    <span style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>Indoor and outdoor themes based costumes we provide</span>
                  </li>
                </ul>
                <style>{`
                  @keyframes gradientBorder2 {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                  }
                `}</style>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="faq-page-wrap mb-4">
        <div className="container">
          <div className="row g-lg-4 gy-5">
            <div className="col-lg-12">
              <div className="faq-area">
                <div className="section-title-and-filter mb-3">
                  <div className="section-title">
                    <h4>FAQ’s &amp; Latest Answer</h4>
                  </div>
                </div>
                <div className="faq-wrap">
                  <div className="row g-3">
                    {faqItems.map((faq, index) => (
                      <div key={index} className="col-lg-6">
                        <div className="accordion accordion-flush">
                          <div className="accordion-item">
                            <h5 className="accordion-header">
                              <button
                                className="accordion-button"
                                type="button"
                                onClick={() =>
                                  setOpenFaq(openFaq === index ? -1 : index)
                                }
                                style={{
                                  background:
                                    openFaq === index ? "#f8f9fa" : "transparent",
                                  boxShadow: "none",
                                }}
                              >
                                {faq.question}
                                <span
                                  style={{
                                    marginLeft: "auto",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {openFaq === index ? (
                                    <FiChevronUp />
                                  ) : (
                                    <FiChevronDown />
                                  )}
                                </span>
                              </button>
                            </h5>
                            <div
                              className="accordion-collapse"
                              style={{
                                display: openFaq === index ? "block" : "none",
                              }}
                            >
                              <div className="accordion-body">{faq.answer}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
